import immutableUpdate from "immutable-update";

const initialState = {
    marcas: null
  
};

const reducers = {

    MARCAS_LOADED: (state, action) => {
      if (state.marcas !== null) {
        return immutableUpdate(state, {
          categories: state.marcas,
        });
      } else {

    return immutableUpdate(
      state,
      {
        marcas: action.payload.data,
      },
    );
      }
  },
};

const reducer = (state = initialState, action) =>
  reducers[action.type] ? reducers[action.type](state, action) : state;

export default reducer;